import { render, staticRenderFns } from "./workMeasureResultDetail.vue?vue&type=template&id=48b4ccc0"
import script from "./workMeasureResultDetail.vue?vue&type=script&lang=js"
export * from "./workMeasureResultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b4ccc0')) {
      api.createRecord('48b4ccc0', component.options)
    } else {
      api.reload('48b4ccc0', component.options)
    }
    module.hot.accept("./workMeasureResultDetail.vue?vue&type=template&id=48b4ccc0", function () {
      api.rerender('48b4ccc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/workMeasureResultDetail.vue"
export default component.exports